import React from 'react';
import ButtonComp from '../../../atoms/Buttons/Presentation/ButtonComp';
import ImageComponent from '../../../atoms/Image/index';

export const CommunicationItem = props => {
  const { contentData = {}, className = '', clickHandler = null } = props;
  const { src = '', alt = '', cardText = '', showButton = true, buttonText = '', buttonItem = '' } = contentData;
  const ariaLableText = `${buttonText} on ${cardText}`;
  return (
    <div className={`communication-card ${className}`}>
      <ImageComponent
        data-testid='image-component'
        srcFile={src || ''}
        alt={alt}
        className='communicationCard-background'
      />
      <div className='communicationCard-content'>
        <div className='communicationCard-text'> {cardText} </div>
        {showButton && buttonText && (
          <ButtonComp
            data-testid={`button-component-${buttonText}`}
            id={`communicationCard_${buttonItem}`}
            className='button whiteButton card-button communicationCard-button'
            type='submit'
            onClickHandler={() => {
              clickHandler(buttonItem);
            }}
            aria-label={ariaLableText}
          >
            {buttonText}
          </ButtonComp>
        )}
      </div>
    </div>
  );
};
